<template>
    <div class="container-fluid">
        <form @submit.prevent="submit" >
        <div class="form-group" v-if="errors.length" >
            <ul class="list-group">
                <li class="list-group-item list-group-item-danger" v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
        </div>
        <div class="row mt-3">
            <div class="col-8 col-sm-8 col-md-8">
                <h3 class="text-center">{{ title }}</h3>
            </div>
            <div class="col-8 col-sm-8 col-md-8">
                <div class="form-group input-group-sm">
                    <label >Telefony kupione</label>
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th class="align-top">
                                    <label >Telefon</label>
                                </th>
                                <th class="align-top text-right">
                                    <label >Cena zakupu</label>
                                </th>
                                <th class="align-top text-right">
                                    <label >Cena na półce</label>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in form.boughtPhones.boughtPhonesItems" :key="item.id">
                                <td>{{ item.phoneName }}</td>
                                <td class="text-right font-weight-bold">{{ printPrice(item.buyPrice) }}</td>
                                <td class="text-right font-weight-bold">{{ printPrice(item.suggestedPrice) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-8 col-sm-8 col-md-8">
                <label>Telefony sprzedane</label>
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th class="align-top">
                                <label >Telefon</label>
                            </th>
                            <th class="align-top text-right">
                                <label >Cena zakupu</label>
                            </th>
                            <th class="align-top text-right">
                                <label >Cena sprzedaży</label>
                            </th>
                            <th class="align-top text-right">
                                <label >Zysk</label>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in form.soldPhones.soldPhonesItems" :key="item.id">
                            <td>{{ item.phoneName }}</td>
                            <td class="text-right">{{ printPrice(item.buyPrice) }}</td>
                            <td class="text-right torre-green font-weight-bold">{{ printPrice(item.soldPrice) }}</td>
                            <td class="text-right torre-green font-weight-bold">{{ printPrice(item.profitPrice) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-8 col-sm-8 col-md-8 mt-3">
                <label >Wydatki</label>
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th class="align-top">
                                <label >Nazwa</label>
                            </th>
                            <th class="align-top text-right">
                                <label >Kwota</label>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in form.expenses.expenseItems" :key="item.id">
                            <td>{{ item.name }}</td>
                            <td class="text-right torre-red-color font-weight-bold">{{ printPrice(item.price) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="row mt-3">
            </div>

            <div class="col-8 col-sm-8 col-md-8 mt-3">
                <div class="form-group input-group-sm">
                <label >AKCESORIA - Łączna sprzedaż akcesoriów</label>
                    <input class="form-control torre-green font-weight-bold" :disabled="canNotEdit" v-model="form.accessoriesPrice"/>
                </div>
            </div>
            <div class="col-8 col-sm-8 col-md-8 mt-3">
                <div class="form-group input-group-sm">
                    <label >SERWIS - Łączna sprzedaż usług serwisowych</label>
                    <input class="form-control torre-green font-weight-bold" :disabled="canNotEdit" v-model="form.servicePhonesPrice"/>
                </div>
            </div>
            <div class="col-8 col-sm-8 col-md-8 mt-3">
                <div class="form-group input-group-sm">
                    <label >DOŁADOWANIA - Łącznie sprzedaż doładowań</label>
                    <input class="form-control torre-green font-weight-bold" :disabled="canNotEdit" v-model="form.topUpsPrice"/>
                </div>
            </div>
            <div class="col-8 col-sm-8 col-md-8 mt-3">
                <div class="form-group input-group-sm">
                    <label >TERMINAL - Łączna wartość płatności kartą</label>
                    <input class="form-control" :disabled="canNotEdit" v-model="form.terminalPrice"/>
                </div>
            </div>
            <div class="col-8 col-sm-8 col-md-8 mt-3">
                <div class="form-group input-group-sm">
                    <label >UTARGI - Stan gotówki w kopercie na koniec dnia</label>
                    <input class="form-control" :disabled="canNotEdit" v-model="form.revenuePrice"/>
                </div>
            </div>
            <div class="col-8 col-sm-8 col-md-8 mt-3">
                <div class="form-group input-group-sm">
                    <label >TELEFONY - Stan gotówki w kopercie na koniec dnia</label>
                    <input class="form-control" :disabled="canNotEdit" v-model="form.phonesPrice"/>
                </div>
            </div>
            <div class="col-8 col-sm-8 col-md-8 mt-3">
                <input class="btn btn-success torre-btn btn-sm mr-2" type="submit" value="Zapisz" v-if="isAdmin()">
                <router-link class="btn btn-secondary btn-sm" :to="{ name: 'reports' }">Anuluj</router-link>
                <button class="btn btn-dark btn-sm" @click.prevent="deleteReportConfirm()" v-if="isAdmin()" >Usuń</button>
            </div>
        </div>
        </form>
        <div class="row mt-5 mb-4">
            <div class="col-8 col-sm-8 col-md-8">
                <h5 class="">Komentarze</h5>
            </div>
            <div class="col-8 col-sm-8 col-md-8">
                <div class="row">
                    <div class="col-4 col-sm-4 col-md-4">
                        <div class="form-group input-group-sm">
                            <textarea class="form-control" rows="3" v-model="commentForm.content"></textarea>
                        </div>
                        <div class="form-group input-group-sm">
                            <button class="btn btn-success torre-btn btn-sm mr-2" @click.prevent="addComment()" >Komentuj</button>
                        </div>
                    </div>
                </div>
                <div class="row" v-for="comment in comments" :key="comment.id">
                    <div class="col-4 mt-3">
                        <div class="card">
                            <div class="card-body">
                                <p class="card-text" v-html="comment.content"></p>
                                <div class="card-footer text-muted">
                                    {{ commentTitle(comment) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {pl} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import datepicker from 'vuejs-datepicker'
import alertify from 'alertifyjs'
import ReportsService from "@/components/reports/ReportsService"
import Formatter from "@/service/Formatter"

const formatter = new Formatter()
const reportsService = new ReportsService()

export default {
    components: {
      datepicker
    },
    name: "ReportEdit",
    data: function () {
        return {
            errors: [],
            lang: pl,
            storesOptions: [],
            comments: [],
            commentForm: {
                content: "",
                reportId: this.$route.params.id,
                createDate: moment().format("YYYY-MM-DD HH:mm:ss")
            },
            form: {
                reportId: "-1",
                storeId: -1,
                createDate: moment().format("YYYY-MM-DD HH:mm:ss"),
                accessoriesPrice: "",
                servicePhonesPrice: "",
                topUpsPrice: "",
                revenuePrice: "",
                phonesPrice: "",
                terminalPrice: "",
                storeName: "",
                boughtPhones: {
                    boughtPhonesItems: []
                },
                expenses: {
                    expenseItems: []
                },
                soldPhones: {
                    soldPhonesItems: []
                }
            }
        }
    },
    computed: {
        title() {
            return `Raport / ${this.form.storeName} / ${formatter.date.YMD(this.form.createDate)}`
        },
        canNotEdit() {
            return !this.isAdmin()
        }
    },
    created() {
        this.initStoresOptions()
    },
    methods: {
        commentTitle(comment) {
            return `${formatter.date.YMDHHmm(comment.date)} ${comment.createdBy}`
        },
        addComment() {
            reportsService.addComment(this.commentForm, this.onAddCommentSuccess, this.onAddCommentError)
        },
        onAddCommentSuccess(data) {
            alertify.set('notifier','position', 'top-center');
            alertify.success("Komentarz został dodany").delay(3);
            this.loadReport()
            this.commentForm.content = ""
        },
        onAddCommentError() {
            alertify.set('notifier','position', 'top-center');
            alertify.error("Nie można dodać komentarza.").delay(3);
        },
        printPrice(price) {
            return formatter.price.ZL(price)
        },
        deleteReportConfirm() {
            const that = this
            alertify.confirm('', 'Chcesz usunąć raport?', function(){
                that.deleteReport()
                }, function(){},
            );
        },
        deleteReport() {
            const id = this.$route.params.id
            reportsService.deleteReport(id, this.onDeleteSuccess, this.onDeleteError)
        },
        onDeleteSuccess(data) {
            this.$router.push({name: 'reports'})
            alertify.set('notifier','position', 'top-center');
            alertify.success("Raport został usunięty").delay(3);
        },
        onDeleteError(err) {
            console.log(err)
            this.errors = err
            alertify.set('notifier','position', 'top-center');
            alertify.error("Nie można usunąć raportu.").delay(3);
        },
        isAdmin() {
            return reportsService.isAdmin()
        },
        clearPrice(formattedPrice) {
            return formatter.price.clearZL(formattedPrice)
        },
        submit() {
            if (!this.isAdmin) {
                return
            }
            this.clearErrors()
            const formCopy = JSON.parse(JSON.stringify(this.form));
            formCopy.accessoriesPrice = this.clearPrice(this.form.accessoriesPrice)
            formCopy.servicePhonesPrice = this.clearPrice(this.form.servicePhonesPrice)
            formCopy.topUpsPrice = this.clearPrice(this.form.topUpsPrice)
            formCopy.revenuePrice = this.clearPrice(this.form.revenuePrice)
            formCopy.phonesPrice = this.clearPrice(this.form.phonesPrice)
            formCopy.terminalPrice = this.clearPrice(this.form.terminalPrice)
            formCopy.boughtPhones = this.clearPrice(this.form.boughtPhones)
            reportsService.editReport(formCopy, this.onEditSuccess, this.onEditError)
        },
        onEditSuccess(data) {
            this.$router.push({name: 'reports'})
            alertify.set('notifier','position', 'top-center');
            alertify.success("Raport został zapisany").delay(3);
        },
        onEditError(err) {
            this.errors = err
            alertify.set('notifier','position', 'top-center');
            alertify.error("Nie można edytować raportu.").delay(3);
            this.scrolTop()
        },
        initStoresOptions() {
            reportsService.initStores(this.onStoresSuccess)
        },
        onStoresSuccess(data, selectedStore) {
            this.storesOptions = data
            this.form.storeId = selectedStore.id
            this.loadReport()
        },
        clearErrors() {
            this.errors = []
        },
        loadReport() {
            const id = this.$route.params.id
            reportsService.findReport(id, this.onLoadReportSuccess, this.onLoadReportError)
        },
        onLoadReportSuccess(data) {
            this.form.reportId = this.$route.params.id
            this.form.createDate = data.createDate
            this.form.totalIncome = data.totalIncome
            this.form.accessoriesPrice = this.printPrice(data.accessoriesPrice)
            this.form.servicePhonesPrice = this.printPrice(data.servicePhonesPrice)
            this.form.topUpsPrice = this.printPrice(data.topUpsPrice)
            this.form.revenuePrice = this.printPrice(data.revenuePrice)
            this.form.phonesPrice = this.printPrice(data.phonesPrice)
            this.form.terminalPrice = this.printPrice(data.terminalPrice)
            this.form.boughtPhones = data.boughtPhones
            this.form.expenses = data.expenses
            this.form.soldPhones = data.soldPhones
            this.form.storeName = data.storeName
            this.comments = data.comments
        },
        onLoadReportError(err) {
            console.log(err)
            this.$router.push({name: 'phones'})
            alertify.set('notifier','position', 'top-center');
            alertify.error("Nie można pobrać raportu.").delay(3);
        },
        scrolTop() {
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/reports/ReportEdit.vue